export default __webpack_public_path__ + "static/media/81t.3302e2be.jpg";